"use client";
import DropdownOne from "@/components/search-dropdown/inner-dropdown/DropdownOne";
import Image from "next/image";
import Link from "next/link";

import featureIcon_4 from "@/assets/images/icon/Event2.svg";
import featureIcon_1 from "@/assets/images/icon/Group5.svg";
import featureIcon_2 from "@/assets/images/icon/Gender2.svg";
import featureIcon_3 from "@/assets/images/icon/Register2.svg";
import ageGroup from "@/assets/images/icon/ageGroup2.svg";
import weight from "@/assets/images/icon/weight2.svg";

import add_to_cart_with_blue_background from "@/assets/images/logo/add_to_cart_with_blue_background..svg";
import {
  CartItem,
  addItem,
  removeAndAddItems,
  removeItem,
  selectCartItems,
} from "../../../redux/features/cartSlice";

import Loader from "@/components/Loader/Loader";
import axiosInstance from "@/service/axiosInstance";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import {
  correctUrlString,
  formatAgeForUi,
  formatDateRange,
  kebabCase,
} from "@/utils/utils";
import { useParams, useRouter, useSearchParams } from "next/navigation";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import eventImage from "../../../../public/assets/images/event-images/image1.jpg";
import { addFilter, filterItems } from "@/redux/features/filterSlice";
import {
  setCount,
  setEvents,
  setLoading,
  setPaginatedEvents,
} from "@/redux/features/eventSlice";
import { toast } from "react-toastify";
import { setItem } from "@/redux/features/bulkUploadSlice";
import PrivateEventCard from "./PrivateEventCard";
import RemoveEventModal from "@/modals/RemoveEventModal";
import close from "@/assets/images/shape/close.svg";
import filterIcon from "@/assets/images/shape/filter.svg";
import HandleCart from "@/components/common/HandleCart";
import {
  APP_NAME,
  ClassificationTypes,
  emptyFilter,
  ToastOptions,
  USER_ROLE,
} from "@/utils/enum";
import BuyButton from "@/components/common/BuyButton";
import GreyboxForCard from "@/components/common/GreyboxForCard";
import { formatPrice } from "@/components/amount";
import ClearCart from "@/components/clearCart";
import Pagination from "@mui/material/Pagination";

const ListingOneArea = () => {
  const searchParams = useParams();
  const urlParams = useSearchParams();
  const filter = useSelector(filterItems);
  const title = urlParams.get("title");
  // const swapData = useSelector((state: any) => state.swapData.data);
  const userRoleVal = useSelector((state: any) => state.auth.userRole);
  if (
    searchParams?.slug &&
    Array.isArray(searchParams.slug) &&
    searchParams.slug.length > 1
  ) {
    searchParams.second = decodeURIComponent(searchParams.slug[1]);
  }
  const itemsPerPage = 8;

  const dispatch = useDispatch();
  const router = useRouter();
  const cart = useSelector(selectCartItems);
  const event = useSelector((state: any) => state.events.events);
  const loading = useSelector((state: any) => state.events.eventLoading);
  const cartItemCount = useSelector((state: any) => state.cart.items);
  const [cartData, setCartData] = useState(cart);
  const [currentPage, setcurrentPage] = useState(1);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 576);
  const [showFilter, setShowFilter] = useState(false);
  // const [data, setData] = useState<any>([]);
  // const [loading, setLoading] = useState(false);
  const [token, setToken] = useState<string | null>(null);
  const [toggleRemoveItemsModal, setToggleRemoveItemsModal] = useState(false);
  const [clearCart, setClearCart] = useState(false);
  const count = useSelector((state: any) => state.events.count);
  const startItem = Math.min(count, (currentPage - 1) * itemsPerPage + 1);
  const endItem = Math.min(count, currentPage * itemsPerPage);

  const itemToAdd: any = useRef(null);

  const getData = async (currentPage: any, filters: any) => {
    try {
      dispatch(setLoading(true));
      setShowFilter(false);
      console.log("calling api");
      const resp: any = await axiosInstance.post("/events", {
        sort: "createdAt:desc",
        page: filters.currentPage,
        limit: 8,
        eventsType: filters.eventsType,
        age: filters.age?.value,
        venue_address: filters.location?.value,
        school: filters.school?.value,
        category: filters.category,
        gender: filters.gender,
        eventsMode: filters.eventsMode,
        title: filters.title,
        registrationsOpen: filters.registrationsOpen,
        privateEvents: filters.privateEvents,
      });
      // console.log("🚀 ~ getData ~ resp:", resp);

      let updated = resp.events;

      // setCount(resp?.meta.pagination.total);
      updated = updated.map((item: any) => ({
        ...item,
        inCart: cart.filter((val) => val.id === item.id)[0]?.inCart || 0,
      }));

      dispatch(setLoading(false));
      dispatch(setEvents(updated));
      dispatch(setCount(resp?.meta.pagination.total));
      handlePageChange(filters.currentPage || currentPage, updated);
      // setData(updated);
    } catch (error) {
      console.log(error);
    } finally {
      dispatch(setLoading(false));
    }
  };

  const getCart = (updated: any) => {
    for (let index in updated) {
      const cartCount = cart.filter((val) => val.id === updated[index].id);
      updated[index] = { ...updated[index], inCart: cartCount.length };
    }
    dispatch(setEvents(updated));

    // setData((prev: any) => {
    //   prev = [...updated];
    //   return prev;
    // });
  };

  const handleResetFilter = () => {
    dispatch(addFilter(emptyFilter));
    getData(currentPage, emptyFilter);
  };

  const handleAddToCart = (data: CartItem) => {
    // if (swapData) {
    //   const isIndividualEvent =
    //     swapData.events.type === "INDIVIDUAL" &&
    //     data?.attributes?.fees_category?.data?.attributes?.name ===
    //       ClassificationTypes.Individual;
    //   const isPrivateEvent =
    //     swapData.events.type === "PRIVATE" &&
    //     data?.attributes?.is_private === true;

    //   // Only Individual or Private events are allowed during a swap
    //   if (
    //     !(isIndividualEvent || isPrivateEvent) ||
    //     data.inCart !== 0 ||
    //     cartItemCount.length > 0
    //   ) {
    //     toast.error(
    //       "To proceed, ensure the selected event type matches the swapped event type (either Individual or Private). Additionally, only one event can be registered while a swap is active"
    //     );
    //     return;
    //   }
    // }
    const eventDateStr = data?.attributes?.event_register_start_date; // This is the date string
    const eventEndStr = data?.attributes?.event_register_end_date; // This is the date string
    const eventStartDate = new Date(eventDateStr)
      .setHours(0, 0, 0, 0)
      .valueOf(); // Convert the string to a Date object

    const eventEndDate = new Date(eventEndStr)
      .setHours(23, 59, 59, 999)
      .valueOf(); // Convert the string to a Date object

    // Get the current date and time in the Indian time zone
    const now = new Date().getTime();

    // // Compare the two dates
    if (eventStartDate < now && eventEndDate > now) {
      const redux_response = dispatch(addItem({ data, persist: false }));

      if (typeof redux_response === "boolean") {
        itemToAdd.current = { data, persist: false };
        setToggleRemoveItemsModal(true);
        return false;
      }
      return true;
    } else {
      if (eventStartDate > now) {
        toast.error("Event registration has not started yet.", ToastOptions);
      } else {
        toast.error(
          "Sorry, you missed the deadline for registration. Explore our other events!",
          ToastOptions,
        );
      }
      return false;
    }
  };

  const handleRemoveFromCart = (data: CartItem) => {
    // Dispatch the removeItem action with the item's ID
    dispatch(removeItem({ data, persist: false }));
  };

  const handleOnclick = async (item: any) => {
    router.push("/cart");
  };

  const handlePageChange = (pageNumber: number, data?: any[]) => {
    setcurrentPage(pageNumber);

    const element = document.getElementById("cart-section");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }

    const startIndex = (pageNumber - 1) * itemsPerPage;
    dispatch(
      setPaginatedEvents(
        data
          ? data.slice(startIndex, startIndex + itemsPerPage)
          : event.slice(startIndex, startIndex + itemsPerPage),
      ),
    );
  };

  const onPageChange = async (
    event: React.ChangeEvent<unknown>,
    value: number,
  ) => {
    setcurrentPage(value);
    const newFilter = {
      ...filter,
      currentPage: value,
    };
    dispatch(addFilter(newFilter));
    await getData(value, newFilter);
    handlePageChange(value);
  };

  const checkMaxCapacityLimit = async (item: any) => {
    try {
      // if (swapData) {
      //   if (
      //     item?.attributes?.fees_category?.data?.attributes?.name !==
      //       ClassificationTypes.Individual ||
      //     item.attributes.is_private != true ||
      //     item.inCart !== 0 ||
      //     cartItemCount.length > 0
      //   ) {
      //     toast.error(
      //       "The event must be individual, and only one event can be registered while swap is active."
      //     );
      //     return;
      //   }
      // }

      //? check here if it has reached the maxCapacity or not
      const response: any = await axiosInstance.post(
        "/check-event-maxcapacity",
        {
          data: [
            {
              eventId: item.id,
              maxCapacity: item.attributes.Maximum_Batch_Capacity,
              itemCount: item.inCart || 1,
            },
          ],
        },
      );
      if (response?.status != 200) {
        console.log("inside====>", response);
        throw new Error(response.errorMessage);
      }
      return false;
    } catch (error: any) {
      console.log("Error handleSubmit CommonBanner", { error });
      toast.error(error.message, ToastOptions);
      return true;
    }
  };

  const handleBulkUpload = async (item: any) => {
    console.log({ item: item });
    // if(item.attributes.fees_category.data.attributes.name!=ClassificationTypes.Individual){
    //   toast.error("Only Bulk upload in ")
    // }
    // const confirmed = window.confirm("Are you sure you want to delete the previous upload data?");
    // if (!confirmed) {
    // 	return;
    // }
    setLoading(true);
    try {
      const response: any = await axiosInstance.delete(
        "bulkUploadCsv/deleteData",
      );
      const { acknowledged, deletedCount } = response?.data || {};
      if (deletedCount > 0) {
        // toast.info("Successfully deleted the previous uploaded data!");
        // setUserBulkUploadData(null);
      } else {
        // setUserBulkUploadData(null);
        // console.log({ deletedCount });
        // toast.info("No Data Found!");
      }
      //? settting array as we may get other event of same category with diffrent attributes(age,grade)
      dispatch(setItem(item));
      router.push("bulk-upload");
    } catch (error) {
      toast.error(
        "Something went wrong while fetching user csv data!",
        ToastOptions,
      );
      console.log("handleBulkUpload ===>", { error });
    } finally {
      setLoading(false);
    }
  };

  const handleGroupBulkUpload = async (item: any) => {
    setLoading(true);
    try {
      // const response: any = await axiosInstance.delete(
      //   "bulkUploadCsv/deleteData"
      // );
      //const { acknowledged, deletedCount } = response?.data || {};
      //if (deletedCount > 0) {
      // toast.info("Successfully deleted the previous uploaded data!");
      // setUserBulkUploadData(null);
      //} else {
      // setUserBulkUploadData(null);
      // console.log({ deletedCount });
      // toast.info("No Data Found!");
      //}
      //? settting array as we may get other event of same category with diffrent attributes(age,grade)
      dispatch(setItem(item));
      router.push("group-bulk-upload");
    } catch (error) {
      toast.error(
        "Something went wrong while fetching user csv data!",
        ToastOptions,
      );
      console.log("handleBulkUpload ===>", { error });
    } finally {
      setLoading(false);
    }
  };

  const closeEventModal = () => {
    setToggleRemoveItemsModal(false);
  };

  const removePreviousEvents = () => {
    dispatch(removeAndAddItems(itemToAdd.current));
    setToggleRemoveItemsModal(false);
  };

  useEffect(() => {
    let matchingCartItem: any;
    const updatedData: any = event.map((item: any) => {
      matchingCartItem = cart.find((val: any) => val.id === item.id);
      return {
        ...item,
        inCart: matchingCartItem ? matchingCartItem.inCart : 0,
      };
    });
    // setData(updatedData);
    dispatch(setEvents(updatedData));
    const startIndex = (currentPage - 1) * itemsPerPage;
    dispatch(
      setPaginatedEvents(
        updatedData.slice(startIndex, startIndex + itemsPerPage),
      ),
    );
  }, [cart]);

  useEffect(() => {
    const mergedFilter = { ...emptyFilter };
    dispatch(addFilter(mergedFilter));
    getData(mergedFilter.currentPage || currentPage, mergedFilter);
    if (process.env.NEXT_PUBLIC_APP_NAME == APP_NAME.VIBGYOR_ONE) {
      if (
        cart?.length > 0 &&
        cart[0]?.attributes?.fees_description?.data.id != 13
      ) {
        setClearCart(true);
      }
    }
    // getData(currentPage, filter);
    // setToken(localStorage.getItem("token"));
  }, []);

  console.log("events--", event);

  return (
    <div
      className="property-listing-six bg-pink-two md-pt-0 pb-150 xl-pb-120"
      style={{ backgroundColor: "#F5F5FF" }}
    >
      {loading && <Loader />}
      {toggleRemoveItemsModal && (
        <RemoveEventModal
          show={toggleRemoveItemsModal}
          closeEventModal={closeEventModal}
          removePreviousEvents={removePreviousEvents}
        />
      )}
      <div className="container container-large">
        <div className="row events-container">
          <div className="col-lg-8">
            <div className="">
              <div className="align-items-center d-sm-flex justify-content-between listing-header-filter mb-10 mt-10 mt-md-3 mt-lg-0">
                <div>
                  Showing{" "}
                  <span className="color-dark fw-500">
                    {event?.length > 0
                      ? (filter.currentPage - 1) * itemsPerPage + 1
                      : 0}
                  </span>
                  {event?.length > 0 && (
                    <>
                      <span>-</span>
                      <span className="color-dark fw-500">
                        {event?.length > 0
                          ? Math.min(filter.currentPage * itemsPerPage, count)
                          : 0}
                      </span>
                    </>
                  )}{" "}
                  of <span className="color-dark fw-500">{count}</span> Results
                </div>
              </div>
              {event?.length > 0 ? (
                <div className="d-flex flex-wrap gx-xxl-5">
                  {/* {event} */}
                  {event?.map((item: any) => (
                    <div
                      key={item?.id}
                      className="col-md-6 d-flex mb-15 wow px-2"
                    >
                      {!item?.attributes?.is_private ? (
                        <div
                          className="listing-card-one border-25 h-100 w-100 "
                          style={{
                            border: "1px solid rgba(0, 0, 0, 0.36)",
                            borderRadius: "1rem",
                          }}
                        >
                          <div className="img-gallery p-2">
                            <div className="position-relative border-25 overflow-hidden">
                              {item?.attributes?.fees_sub_type?.data.attributes
                                ?.name == "Competition" && (
                                <div
                                  style={{
                                    position: "absolute",
                                    zIndex: "1",
                                    marginTop: "12px",
                                    padding: "11px 16px",
                                    gap: "10px",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    display: "flex",
                                    maxHeight: "32px",
                                    maxWidth: "113px",
                                    marginRight: "10px",
                                    right: 0,
                                    // borderRadius: "34px",
                                    border: "1px solid  #212121",
                                    color: "#310000",
                                    background: "#FFF",
                                  }}
                                >
                                  {"Competition"}
                                </div>
                              )}
                              {item?.attributes?.fees_sub_type?.data.attributes
                                ?.name == "Workshop" && (
                                <div
                                  style={{
                                    marginTop: "12px",
                                    position: "absolute",
                                    zIndex: "1",
                                    padding: "11px 16px",
                                    gap: "10px",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    display: "flex",
                                    maxHeight: "32px",
                                    maxWidth: "99px",
                                    marginRight: "10px",
                                    right: 0,
                                    borderRadius: "34px",
                                    border: "1px solid  #212121",
                                    color: "#310000",
                                    background:
                                      "linear-gradient(0deg, rgba(33, 33, 33, 0.12) 0%, rgba(33, 33, 33, 0.12) 100%), #FFF",
                                  }}
                                >
                                  {"Workshop"}
                                </div>
                              )}
                              {item?.attributes?.fees_sub_type?.data.attributes
                                ?.name == "Premier Competition" && (
                                <div
                                  style={{
                                    marginTop: "12px",
                                    position: "absolute",
                                    zIndex: "1",
                                    padding: "11px 16px",
                                    gap: "10px",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    display: "flex",
                                    maxHeight: "32px",

                                    marginRight: "10px",
                                    right: 0,
                                    borderRadius: "34px",
                                    border: "1px solid #3F41D1",
                                    color: "#3F41D1",
                                    background:
                                      "linear-gradient(0deg, rgba(63, 65, 209, 0.12) 0%, rgba(63, 65, 209, 0.12) 100%), #FFF",
                                  }}
                                >
                                  {"Premier Event"}
                                </div>
                              )}
                              {![
                                "Competition",
                                "Workshop",
                                "Premier Competition",
                              ].includes(
                                item?.attributes?.fees_sub_type?.data.attributes
                                  ?.name,
                              ) && (
                                <div
                                  style={{
                                    marginTop: "2px",
                                    position: "absolute",
                                    zIndex: 1,
                                    padding: "11px 16px",
                                    gap: "10px",
                                    justifyContent: "flex-start",
                                    alignItems: "center",
                                    display: "flex",
                                    maxHeight: "32px",
                                    marginRight: "3px",
                                    right: 0,
                                    borderRadius: "34px",
                                    border: "1px solid #212121",
                                    color: "#310000",
                                    background: "#FFF",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    maxWidth: "60%",
                                    fontSize: "0.75rem",
                                    textOverflow: "ellipsis",
                                    top: "4px",
                                  }}
                                  title={
                                    item?.attributes?.fees_sub_type?.data
                                      .attributes?.name
                                  }
                                >
                                  <span
                                    style={{
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      whiteSpace: "nowrap",
                                      display: "block",
                                    }}
                                  >
                                    {
                                      item?.attributes?.fees_sub_type?.data
                                        ?.attributes?.name
                                    }
                                  </span>
                                </div>
                              )}
                              <div className="">
                                <div className="">
                                  <Link
                                    href={{
                                      pathname: `/event/${kebabCase(
                                        item?.attributes?.zone,
                                      )}-${kebabCase(
                                        item?.attributes?.school?.data
                                          ?.attributes?.name,
                                      )}-${kebabCase(
                                        item?.attributes?.fees_category?.data
                                          ?.attributes?.name,
                                      )}-${kebabCase(
                                        item?.attributes?.fees_sub_type?.data
                                          ?.attributes?.name,
                                      )}-${kebabCase(
                                        item?.attributes?.title,
                                      )}/${item?.id}`,
                                      // query: {
                                      //   id: item?.id,
                                      // },
                                    }}
                                    className="d-block"
                                  >
                                    <Image
                                      style={{
                                        height: "306px",
                                        width: "500px",
                                        objectFit: "cover",
                                      }}
                                      src={
                                        correctUrlString(
                                          item?.attributes?.image_link,
                                        )[0] ||
                                        (process.env.NEXT_PUBLIC_APP_NAME ===
                                        APP_NAME.VIBGYOR_VIVA
                                          ? eventImage
                                          : "https://storage.googleapis.com/eduspark-prod-viva-content/Summer-Camp/Feature%20Events/Featured%20EVENTS_3.jpg")
                                      }
                                      height={300}
                                      width={500}
                                      className="w-100"
                                      alt="..."
                                    />
                                  </Link>
                                  {/* </div> */}
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="property-info px-2">
                            <div
                              style={{
                                display: "flex",
                                // minHeight: "5rem",
                                flexDirection: "column",
                                // backgroundColor: "red",
                                gap: "5px",
                              }}
                            >
                              <div className="title tran3s">
                                <Link
                                  href={{
                                    pathname: `/event/${kebabCase(
                                      item?.attributes?.zone,
                                    )}-${kebabCase(
                                      item?.attributes?.school?.data?.attributes
                                        ?.name,
                                    )}-${kebabCase(
                                      item?.attributes?.fees_category?.data
                                        ?.attributes?.name,
                                    )}-${kebabCase(
                                      item?.attributes?.fees_sub_type?.data
                                        ?.attributes?.name,
                                    )}-${kebabCase(
                                      item?.attributes?.title,
                                    )}/${item?.id}`,
                                    // query: {
                                    //   id: item?.id,
                                    // },
                                  }}
                                  className="d-block"
                                  style={{
                                    textDecoration: "none",
                                    color: "black",
                                  }}
                                >
                                  {
                                    item?.attributes?.fees_sub_category?.data
                                      ?.attributes?.name
                                  }
                                </Link>
                              </div>
                              <div style={{ display: "flex" }}>
                                <div className="" style={{}}>
                                  {item?.attributes?.venue_name}
                                </div>

                                {/* <InfoButton InfoButtonData={"Rules Regulation"} /> */}
                              </div>
                              {process.env.NEXT_PUBLIC_APP_NAME ===
                                APP_NAME.VIBGYOR_ONE && (
                                <h6>
                                  <span>
                                    <AccessTimeIcon />
                                  </span>
                                  {item?.attributes?.time_from
                                    ? item.attributes.time_from
                                        .split(":")
                                        .slice(0, -1)
                                        .join(":")
                                    : "N/A"}
                                  {" - "}
                                  {item?.attributes?.time_to
                                    ? item.attributes.time_to
                                        .split(":")
                                        .slice(0, -1)
                                        .join(":")
                                    : "N/A"}
                                </h6>
                              )}
                            </div>
                            <ul className="style-none feature d-flex flex-wrap gap-0 align-items-center">
                              <li
                                className="d-flex align-items-center"
                                style={{ flex: "1 1 0" }}
                              >
                                <GreyboxForCard
                                  icon={featureIcon_1}
                                  label={
                                    item?.attributes?.fees_category?.data
                                      ?.attributes?.name
                                  }
                                  value={
                                    item?.attributes?.fees_category?.data
                                      ?.attributes?.name ===
                                    ClassificationTypes.Individual
                                      ? item?.attributes?.minimum_entry
                                      : item?.attributes?.minimum_entry +
                                        "-" +
                                        item?.attributes?.maximum_entry
                                  }
                                />
                              </li>

                              <li
                                className="d-flex align-items-center"
                                style={{ flex: "1 1 0" }}
                              >
                                <GreyboxForCard
                                  icon={featureIcon_2}
                                  label="Gender"
                                  value={
                                    item.attributes?.gender ||
                                    ClassificationTypes.All
                                  }
                                />
                              </li>

                              <li
                                className="d-flex align-items-center"
                                style={{ flex: "1 1 0" }}
                              >
                                {item.attributes?.Is_Age_Grade === "Grade" ? (
                                  (() => {
                                    // Determine grade values if applicable
                                    // const from = parseInt(
                                    //   item?.attributes?.Grade_From?.data
                                    //     ?.attributes?.short_name || "0",
                                    //   10
                                    // );
                                    // const to = parseInt(
                                    //   item?.attributes?.Grade_To?.data
                                    //     ?.attributes?.short_name || "0",
                                    //   10
                                    // );

                                    return (
                                      <GreyboxForCard
                                        icon={ageGroup}
                                        label="Grade"
                                        value={`
                                          ${item?.attributes?.Grade_From?.data?.attributes?.short_name} - 
                                          ${item?.attributes?.Grade_To?.data?.attributes?.short_name}
                                          `}
                                      />
                                    );
                                  })()
                                ) : (
                                  <GreyboxForCard
                                    icon={ageGroup}
                                    label="Age"
                                    value={formatAgeForUi(
                                      item?.attributes?.age_from || 0,
                                      item?.attributes?.age_to || 0,
                                    )}
                                  />
                                )}
                              </li>
                              <li
                                className="d-flex align-items-center"
                                style={{ flex: "1 1 70%", minWidth: "150px" }}
                              >
                                <GreyboxForCard
                                  icon={featureIcon_4}
                                  label="Event dates"
                                  value={formatDateRange(
                                    item?.attributes?.event_start_date ||
                                      "2024-10-10",
                                    item?.attributes?.event_end_date || null,
                                  )}
                                />
                              </li>
                              <li
                                className="d-flex align-items-center"
                                style={{ flex: "1 1 70%", minWidth: "150px" }}
                              >
                                <GreyboxForCard
                                  icon={featureIcon_3}
                                  label="Registration dates"
                                  value={formatDateRange(
                                    item?.attributes
                                      ?.event_register_start_date ||
                                      "2024-10-10",
                                    item?.attributes?.event_register_end_date ||
                                      null,
                                  )}
                                />
                              </li>
                              {item?.attributes?.weight_from && (
                                <li
                                  className="d-flex align-items-center"
                                  style={{ flex: "1 1 70%", minWidth: "150px" }}
                                >
                                  <GreyboxForCard
                                    icon={weight}
                                    label="Weight"
                                    value={`${
                                      item?.attributes?.weight_from || " "
                                    } - ${item?.attributes?.weight_to || " "}`}
                                  />
                                </li>
                              )}
                            </ul>
                            <div
                              className="d-flex align-items-center justify-content-between"
                              style={{
                                borderTop: "1px dashed #c7c7c7",
                                marginTop: "10px",
                                padding: "5px",
                              }}
                            >
                              <strong className="price fw-500 color-dark">
                                {formatPrice(item?.attributes?.event_fee || 1)}
                              </strong>
                              {!(userRoleVal == USER_ROLE.AGENT) && (
                                <>
                                  <HandleCart item={item} />
                                </>
                              )}
                            </div>
                            {userRoleVal == USER_ROLE.AGENT &&
                              (item.attributes?.fees_category.data.attributes
                                .name == ClassificationTypes.Group ||
                                item.attributes?.fees_category.data.attributes
                                  .name == ClassificationTypes.Individual) && (
                                <div className="d-flex justify-content-between mb-3">
                                  <BuyButton
                                    label="Register"
                                    onButtonClick={async () => {
                                      // if (
                                      //   !(await checkMaxCapacityLimit(item))
                                      // ) {
                                      if (item.inCart > 0) {
                                        handleOnclick(item);
                                      } else {
                                        if (handleAddToCart(item)) {
                                          handleOnclick(item);
                                        }
                                      }
                                      // }
                                    }}
                                  />
                                  {/* <BuyButton
                                    label="Bulk Upload"
                                    onButtonClick={async () => {
                                      handleGroupBulkUpload(item);
                                    }}
                                  /> */}
                                </div>
                              )}
                            {/* {(userRoleVal != USER_ROLE.VT && userRoleVal != USER_ROLE.VC && userRoleVal != USER_ROLE.admin) && (
                              <div className="d-flex  justify-content-between mb-3">
                                <button
                                  onClick={async () => {
                                  //  if (!(await checkMaxCapacityLimit(item))) {
                                      if (item.inCart > 0) {
                                        handleOnclick(item);
                                      } else {
                                        if (handleAddToCart(item)) {
                                          handleOnclick(item);
                                        }
                                      }
                                  //  }
                                  }}
                                  style={{
                                    height: "3.125rem",
                                    //width: "6.875rem",
                                    backgroundColor: "#3F41D1",
                                    //  marginTop:"50px",
                                    marginLeft: "5px",
                                    borderRadius: "12px",
                                    color: "white",
                                    padding: "0 5px",
                                    border: "none",
                                  }}
                                >
                                  Register Now
                                </button>
                                <button
                                  className="px-2"
                                  onClick={async () => {
                                    // handleGroupBulkUpload(item);
                                  }}
                                  style={{
                                    height: "3.125rem",

                                    backgroundColor: "#0f5a7f",
                                    //  marginTop:"50px",
                                    marginRight: "10px",
                                    borderRadius: "12px",
                                    color: "white",

                                    border: "none",
                                  }}
                                >
                                  Bulk Upload
                                </button>
                              </div>
                            )}
                          </div>
                          {(userRoleVal == USER_ROLE.VT || userRoleVal == USER_ROLE.VC) &&
                            item.attributes.fees_category.data.attributes
                              .name == ClassificationTypes.Individual && (
                              <div className="d-flex  justify-content-between mb-3">
                                <button
                                  className="px-2"
                                  onClick={() => {
                                    if (item.inCart > 0) {
                                      handleOnclick(item);
                                    } else {
                                      if (handleAddToCart(item)) {
                                        handleOnclick(item);
                                      }
                                    }
                                  }}
                                  style={{
                                    height: "3.125rem",
                                    // width: "6.875rem",

                                    backgroundColor: "#3F41D1",
                                    //  marginTop:"50px",
                                    marginLeft: "10px",
                                    borderRadius: "12px",
                                    color: "white",

                                    border: "none",
                                  }}
                                >
                                  {swapData &&
                                  swapData.events.type !== "PRIVATE"
                                    ? "Swap Now"
                                    : "Register Now"}
                                </button>
                                <button
                                  className="px-2"
                                  onClick={async () => {
                                    if (!(await checkMaxCapacityLimit(item))) {
                                      handleBulkUpload(item);
                                    }
                                  }}
                                  style={{
                                    height: "3.125rem",

                                    backgroundColor: "#0f5a7f",
                                    marginRight: "10px",
                                    borderRadius: "12px",
                                    color: "white",

                                    border: "none",
                                  }}
                                >
                                  Bulk Upload
                                </button> */}
                          </div>
                          {/* )} */}
                        </div>
                      ) : (
                        <div className="w-100">
                          <PrivateEventCard
                            item={item}
                            handleRemoveFromCart={handleRemoveFromCart}
                            handleAddToCart={handleAddToCart}
                            handleOnclick={handleOnclick}
                          />
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              ) : (
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{
                    height: "60vh",
                    fontSize: "1.25rem",
                    fontWeight: 500,
                  }}
                >
                  <div className="effect d-flex flex-column gap-3">
                    <div
                      className="hover-container"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: "50%",
                        height: "10rem",
                        width: "10rem",
                        border: "2px solid gray",
                        backgroundColor: "white",
                        cursor: "pointer",
                      }}
                    >
                      <Image
                        src={add_to_cart_with_blue_background}
                        alt="Add to cart"
                        style={{ width: "6rem" }}
                      />
                    </div>
                    <div>No events found.</div>
                  </div>
                </div>
              )}
              {/* <ReactPaginate
                breakLabel="..."
                nextLabel={<Image src={icon} alt="" className="ms-2" />}
                onPageChange={async (e) => {
                  console.log("selected page", e);
                  const newFilter = await new Promise((resolve) => {
                    const prevFilter = { ...filter };
                    const newFilter = {
                      ...prevFilter,
                      currentPage: e.selected + 1,
                    };
                    dispatch(addFilter(newFilter));
                    resolve(newFilter);
                    return newFilter;
                  });
                  setTimeout(() => {}, 5000);
                  setcurrentPage(e.selected + 1);
                  await getData(e.selected + 1, newFilter);
                }}
                // we need to substract it accepts index
                forcePage={filter.currentPage - 1}
                pageRangeDisplayed={1}
                pageCount={Math.ceil(count / 8)}
                previousLabel={<Image src={icon} alt="" className="ms-2" />}
                renderOnZeroPageCount={null}
                className="pagination-one d-flex align-items-center justify-content-center justify-content style-none pt-30"
              /> */}
              {event.length > 0 && (
                <div
                  className="my-3"
                  style={{
                    display: "flex",
                    alignItems: "stretch",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <div className="text-sm text-black-1500">
                    Showing {startItem} to {endItem} of {count}
                  </div>
                  <div>
                    <Pagination
                      count={Math.ceil(count / itemsPerPage)}
                      page={currentPage}
                      onChange={onPageChange}
                      shape="rounded"
                      color="primary"
                      sx={{
                        "& .MuiPaginationItem-root.Mui-selected": {
                          backgroundColor: "rgb(63, 65, 209)",
                          color: "#fff",
                        },
                      }}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="col-lg-4 order-lg-first">
            {!isMobile ? (
              <div
                className="advance-search-panel position-relative"
                style={{ marginTop: "2.9rem" }}
              >
                <div className="main-bg">
                  <DropdownOne
                    setcurrentPage={setcurrentPage}
                    handleResetFilter={handleResetFilter}
                    getData={getData}
                    currentPage={currentPage}
                    filter={filter}
                    addFilter={addFilter}
                  />
                </div>
              </div>
            ) : (
              <>
                <button
                  className="d-inline-flex align-items-center px-3 py-1 rounded-pill gap-1 my-2"
                  style={{
                    backgroundColor: "#fff",
                    border: "1px solid #000",
                    cursor: "pointer",
                  }}
                  onClick={() => setShowFilter(true)}
                >
                  <Image
                    src={filterIcon}
                    alt="filterIcon"
                    className="lazy-img icon me-2"
                    style={{
                      height: "1.5rem",
                      width: "1.5rem",
                    }}
                  />
                  Filter
                </button>
              </>
            )}
          </div>
        </div>
      </div>
      {showFilter && (
        <div
          className="modal-overlay position-fixed w-100 d-flex align-items-center justify-content-center bg-dark bg-opacity-50"
          style={{
            zIndex: 1050,
            backdropFilter: "blur(3px)",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
          }}
        >
          <div
            className="advance-search-panel modal-content text-center position-relative"
            style={{
              width: "90%",
              maxWidth: "500px",
              maxHeight: "90vh",
              overflowY: "auto",
              backgroundColor: "#fff",
              borderRadius: "20px",
            }}
          >
            <Image
              src={close}
              alt="close"
              className="position-absolute lazy-img icon"
              style={{
                top: "0.75rem",
                right: "0.75rem",
                height: "2rem",
                width: "2rem",
                cursor: "pointer",
                zIndex: 10,
              }}
              onClick={() => {
                setShowFilter(false);
              }}
            />

            <div className="main-bg p-3">
              <DropdownOne
                setcurrentPage={setcurrentPage}
                handleResetFilter={handleResetFilter}
                getData={getData}
                currentPage={currentPage}
                filter={filter}
                addFilter={addFilter}
              />
            </div>
          </div>
        </div>
      )}

      {clearCart && <ClearCart />}
    </div>
  );
};

export default ListingOneArea;
